import React from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

import { useStyles } from './styles';

interface ISerie {
  name: string;
  data: number[];
}

interface IBarChartProps {
  title?: string;
  series: ISerie;
  categories: string[];
  colors?: string[];
  showLegend?: boolean;
  columnWidth?: string;
  width?: string | number;
  height?: string | number;
  margin?: number;
  unit?: string;
  legendFontSize?: string;
  // data: IOrderDetailed[];
}

const BarChart: React.FC<IBarChartProps> = ({
  title,
  series,
  categories,
  colors,
  showLegend,
  columnWidth,
  width,
  height,
  margin,
  unit,
  legendFontSize,
}) => {
  const classes = useStyles();

  const options: ApexOptions = {
    chart: {
      type: 'bar',
      fontFamily: 'Poppins',
      toolbar: {
        show: false,
      },
      sparkline: {
        enabled: false,
      },
      redrawOnParentResize: true,
      redrawOnWindowResize: true,
      width: '100%',
    },
    grid: {
      show: false,
    },
    plotOptions: {
      bar: {
        columnWidth: columnWidth || '40%',
        borderRadius: 6,
      },
    },
    dataLabels: {
      enabled: false,
    },
    title: {
      text: title?.toLocaleUpperCase(),
      floating: true,
      align: 'center',
      style: {
        fontWeight: 700,
        fontFamily: 'Poppins',
        fontSize: '16px',
      },
    },
    labels: categories,
    xaxis: {
      type: 'category',
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          fontFamily: 'Poppins',
        },
      },
    },
    yaxis: {
      max: unit === '%' ? 100 : undefined,
      tickAmount: 4,
      axisBorder: {
        show: true,
      },
      title: {
        text: series.name,
        style: {
          fontWeight: 500,
        },
      },
      labels: {
        formatter(val: any) {
          if (unit === '%') {
            return `${Number(val).toFixed(0)}%`;
          }
          return `${Number(val).toFixed(0)}`;
        },
      },
    },
    legend: {
      show: showLegend,
      fontSize: legendFontSize || '10%',
      markers: {
        width: 8,
        height: 8,
      },
    },
    colors: colors || ['#C4C6C9', '#7030A0'],
  };

  return (
    <div className={classes.root} style={{ marginBottom: margin }}>
      <Chart
        options={options}
        series={[series]}
        type="bar"
        height={height || '100%'}
        width={width || '100%'}
      />
    </div>
  );
};

export default BarChart;
